import { useQuery } from 'urql';
import { graphql } from '../../gql';
import { ConfigQuery } from '../../gql/graphql';
import { getCookie } from '../../helper/cookie';

export const combineConfig = (dataNew?: ConfigQuery) => {
  const data = {
    NOME: dataNew?.currentCompany?.name,
    NREDUZ: dataNew?.currentCompany?.companyName,
    CODIGO: dataNew?.currentCompany?.cod,
    PODEGRADE: dataNew?.config?.grade?.habilitado ?? true,
    PODEPARAPAR: dataNew?.config?.parapar?.habilitado ?? true,
    PODESURFACAGEM: dataNew?.config?.surfacado?.habilitado ?? true,
    PODEMONTAGEM: dataNew?.config?.surfacado?.montagem ?? false,
    PODECOLOCARACAO: dataNew?.config?.surfacado?.coloracao ?? false,
    PODETRACAGEMREMOTA: dataNew?.config?.surfacado?.tracagemRemota ?? false,
    PODEPARAPARMONTAGEM: dataNew?.config?.parapar?.montagem ?? false,
    PODEPARAPARTRACAGEMREMOTA: dataNew?.config?.api?.tracagemLenteAcabada ?? false,
    PODEPARAPARCOLORACAO: dataNew?.config?.api?.coloracaoLenteAcabada ?? false,
    NOVAPAGINAPARAPAR: dataNew?.config?.api?.novaPaginaParAPar ?? false,
    NOVAPAGINAGRADE: dataNew?.config?.api?.novaPaginaGrade ?? false,
    blockedFiscal: dataNew?.config?.blockedFiscal ?? false,
    blockedCommercial: dataNew?.config?.blockedCommercial ?? false,
    blockedFinancial: dataNew?.config?.blockedFinancial ?? false,
    newStockLens: dataNew?.config?.api?.newStockLens ?? false,
  };
  return data;
};

const Config = graphql(`
  query config {
    currentCompany {
      cod
      name
      companyName
      cnpj
    }
    config {
      parapar {
        habilitado
        montagem
      }
      grade {
        habilitado
      }
      surfacado {
        habilitado
        light
        proId
        top
        drive
        office
        visaoSimples
        smart
        coloracao
        montagem
        tracagemRemota
      }
      api {
        novaPaginaGrade
        novaPaginaParAPar
        novaPaginaBoleto
        hasMainAddress
        hubEnabled
        coloracaoLenteAcabada
        tracagemLenteAcabada
        newStockLens
      }
      blockedFiscal
      blockedCommercial
      blockedFinancial
      targetedCampaign
    }
  }
`);

export const useConfigGQL = () => {
  const clientCod = getCookie('client_cod');

  const pause = !clientCod;

  return useQuery({
    query: Config,
    pause,
  });
};

export const useConfig = () => {
  const clientCod = getCookie('client_cod');

  const pause = !clientCod;

  const [dataConfig] = useQuery({
    query: Config,
    pause,
  });

  const error = dataConfig.error;
  const data = combineConfig(dataConfig.data);

  return {
    data: data,
    loading: !error && !data,
    fetching: dataConfig.fetching,
    error: error,
  };
};
